import { render, staticRenderFns } from "./_PageFooter.vue?vue&type=template&id=fa175214"
import script from "./_PageFooter.vue?vue&type=script&lang=js"
export * from "./_PageFooter.vue?vue&type=script&lang=js"
import style0 from "./_PageFooter.vue?vue&type=style&index=0&id=fa175214&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports